import SettingModule from "./SettingModule.js";
import PaperModule from "./PaperModule.js";
import NewsModule from "./NewsModule.js";

import { createStore } from "vuex";

export default createStore({
  state: {
    mode: "dark",
  },
  modules: {
    SettingModule,
    PaperModule,
    NewsModule,
  },
  getters: {
    screenshot(state) {
      const screenshot = {};
      Object.keys(state).forEach((moduleName) => {
        screenshot[moduleName] = state[moduleName];
      });
      return screenshot;
    },
    isDarkMode(state) {
      return state.mode === "dark";
    },
  },
  mutations: {
    updateScreenshot(state, { screenshot }) {
      Object.entries(screenshot).forEach(([moduleName, moduleState]) => {
        Object.assign(state[moduleName], moduleState);
      });
    },
    toggleMode(state) {
      state.mode = state.mode === "light" ? "dark" : "light";

      if (state.mode === "dark") {
        document.documentElement.classList.remove("light");
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
        document.documentElement.classList.add("light");
      }
    },
    setMode(state, { mode }) {
      state.mode = mode;

      if (state.mode === "dark") {
        document.documentElement.classList.remove("light");
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
        document.documentElement.classList.add("light");
      }
    },
  },
  actions: {
    ResetGeneration({ commit }) {
      commit("PaperDownloadModule/dropBytesIO");
    },
    initializeMode({ commit }) {
      // if (
      //   window.matchMedia &&
      //   window.matchMedia("(prefers-color-scheme: dark)").matches
      // ) {
      //   commit("setMode", {
      //     mode: "dark",
      //   });
      // } else {
      //   commit("setMode", {
      //     mode: "light",
      //   });
      // }
      commit("setMode", {
        mode: "dark",
      });

      const savedMode = localStorage.getItem("colorMode");
      if (savedMode) {
        commit("setMode", {
          mode: savedMode,
        });
      }
    },
  },
});
